import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function LoadingSpinner({ className }) {
  return (
    <div
      className={classnames(className, 'w-100 loading-spinner')}
      data-test-id="loading-wrapper"
    />
  );
}

LoadingSpinner.propTypes = {
  className: PropTypes.string
};

LoadingSpinner.defaultProps = {
  className: null
};
